import React from "react";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const CustomSlider = styled(Slider)({
  color: "#1CB5AF", // Teal color
  height: 5,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 26,
    width: 26,
    backgroundColor: "#fff",
    border: "5px solid currentColor",
    "&:hover": {
      boxShadow: "0 0 0 8px rgba(0,0,0,0.16)",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    fontWeight: 600,
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#1CB5AF",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

const marks = [
  { value: 0, label: "0" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 150, label: "150" },
  { value: 200, label: "200" },
  { value: 250, label: "250" },
  { value: 300, label: "300" },
  { value: 350, label: "350" },
  { value: 400, label: "400" },
  { value: 450, label: "450" },
  { value: 500, label: "500" },
];

interface SliderCompProps {
  value: number;
  onChange: (event: Event, newValue: number | number[]) => void;
}

const RadiusSliderComp: React.FC<SliderCompProps> = ({ value, onChange }) => {
  return (
    <Box sx={{ margin: "0 auto", paddingX: 2 }}>
      <CustomSlider
        defaultValue={value}
        step={50} // Set step to match the interval between marks
        min={0} // Set minimum value
        max={500} // Set maximum value
        onChange={onChange}
        marks={marks} // Use the marks array
        valueLabelDisplay="auto"
      />
    </Box>
  );
};

export default RadiusSliderComp;
